import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApplicationPolicyListService {
  private url = environment.apiUrl;

    constructor(private httpClient: HttpClient) {}

    applicationPolicyList(query: any): Observable<any> {
      let params = new HttpParams();

      if (query.UserType) params = params.set('UserType', query.UserType);
      if (query.ApplicationNo) params = params.set('ApplicationNo', query.ApplicationNo);
      if (query.PolicyNo) params = params.set('PolicyNo', query.PolicyNo);
      if (query.ProductId) params = params.set('ProductId', query.ProductId);
      if (query.PlanId) params = params.set('PlanId', query.PlanId);
      if (query.InsuredName) params = params.set('InsuredName', query.InsuredName);
      if (query.ApplicationStatusId !== null && query.ApplicationStatusId !== undefined) {
        params = params.set('ApplicationStatusId', query.ApplicationStatusId.toString());
      }
      if (query.QAgentId) params = params.set('QAgentId', query.QAgentId);
      if (query.AgentId) params = params.set('AgentId', query.AgentId);
      if (query.BuyFrom) params = params.set('BuyFrom', query.BuyFrom);
      if (query.PageNumber) params = params.set('PageNumber', query.PageNumber.toString());
      if (query.PageSize) params = params.set('PageSize', query.PageSize.toString());

      return this.httpClient.get(`${this.url}/application`, { params });
    }
}
